/**
 * Calendar days as "YYYY-MM-DD", read and written in the device's own time
 * zone. `new Date("2026-10-28")` is midnight UTC — the evening of the 27th
 * west of Greenwich — so a day read that way and written back from its local
 * date moved back a day, and again each time the filter was opened.
 */

/** "2026-10-28" → local midnight of that day; anything else → undefined. */
export const parseLocalYMD = (value: string | null | undefined): Date | undefined => {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value ?? '');
  if (!match) {
    return undefined;
  }
  return new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
};

/** A date (or what a date picker hands back) → its local day as "YYYY-MM-DD". */
export const toLocalYMD = (value: Date | string | number | null | undefined): string | undefined => {
  if (value == null || value === '') {
    return undefined;
  }
  const date = typeof value === 'string' ? parseLocalYMD(value) ?? new Date(value) : new Date(value);
  if (Number.isNaN(date.getTime())) {
    return undefined;
  }
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
};
